import React from "react";

const FallBack = () => {
  return <div> falling back man</div>;
};

export default FallBack;
